import { useCallback } from "react";

//

interface HitOptions {
  callback?: () => void;
  ctx?: object;
  params?: {
    order_price: number;
    currency: string;
  };
  referer?: string;
  title?: string;
}

interface UserParams {
  UserID: number | string;
  [key: string]: unknown;
}

type Params = Record<string, unknown>;

//

interface YM {
  (method: "init", options: unknown): void;
  (method: "hit", url: string, options?: HitOptions): void;
  (method: "reachGoal", targetName: string): void;
  (method: "params", params: Params): void;
  (method: "userParams", params: UserParams): void;
}

//

export const useYandexMetrica = () => {
  const metrikaId = process.env.NEXT_PUBLIC_YANDEX_METRIKA_ID;
  const _ym = typeof window !== "undefined" ? window.ym : null;

  const ym: YM = useCallback(
    (...params) => {
      if (_ym) _ym(metrikaId, ...params);
    },
    [_ym, metrikaId],
  );

  const init = useCallback((options: unknown) => ym("init", options), [ym]);
  const hit = useCallback((url: string, options?: HitOptions) => ym("hit", url, options), [ym]);
  const reachGoal = useCallback((targetName: string) => ym("reachGoal", targetName), [ym]);
  const params = useCallback((params: Params) => ym("params", params), [ym]);
  const userParams = useCallback((params: UserParams) => ym("userParams", params), [ym]);

  return { init, hit, reachGoal, params, userParams };
};
